export const selectSamplingTrackingDetailedState = (state) =>
  state.samplingTrackingDetailed || {};

export const selectTableData = (state) =>
  selectSamplingTrackingDetailedState(state).detailedData || [];

export const selectTotal = (state) =>
  selectSamplingTrackingDetailedState(state).totalSamplers || 0;

export const selectLoading = (state) =>
  selectSamplingTrackingDetailedState(state).loading || false;

export const selectError = (state) =>
  selectSamplingTrackingDetailedState(state).error;

export const selectPagination = (state) =>
  selectSamplingTrackingDetailedState(state).pagination || { currentPage: 1, pageSize: 10, total: 0 };

export const selectCurrentPage = (state) =>
  selectPagination(state).currentPage || 1;

export const selectPageSize = (state) =>
  selectPagination(state).pageSize || 10;